module.exports = __webpack_public_path__ + "img/lsys.9887e707.jpg";